import * as React from 'react';
import Layout from '../components/Utilities/Layout';
import { Alert, Box, Button, ButtonProps, CircularProgress, Dialog, DialogContent, DialogTitle, FormControlLabel, Grid, LinearProgress, ListItemIcon, ListItemText, Menu, MenuItem, Stack, Switch, Typography } from '@mui/material';
import Common from '../utilities/common';
import $ from "jquery";
import HomeWorkOutlinedIcon from '@mui/icons-material/HomeWorkOutlined';
import ComunidadAutonomaNew from './ComunidadAutonomaNew';
import { ComunidadAutonoma } from './ComunidadAutonoma';
import { DataGrid, GridRowSelectionModel, GridRowId, GridCsvExportOptions, GridCsvGetRowsToExportParams, gridExpandedSortedRowIdsSelector, useGridApiContext, GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import ComunidadAutonomaDelete from './ComunidadAutonomaDelete';
import ComunidadAutonomaEdit from './ComunidadAutonomaEdit';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import SecurityTrimmer from '../components/Utilities/SecurityTrimmer';
import { Entity, PermissionLevel } from '../utilities/Permisos';
import EntitySettings from '../components/EntitySettings';
import ErrorDialog from '../components/Utilities/ErrorDialog';
import EditIcon from '@mui/icons-material/Edit';
import EntityViews from '../components/EntityViews';
import FeatureManager from '../components/Utilities/FeatureManager';

const getFilteredRows = ({ apiRef }: GridCsvGetRowsToExportParams) =>
    gridExpandedSortedRowIdsSelector(apiRef);

const ExportButton = () => {
    const apiRef = useGridApiContext();
  
    const handleExport = (options: GridCsvExportOptions) =>
      apiRef.current.exportDataAsCsv(options);
  
    const buttonBaseProps: ButtonProps = {
      color: 'primary',
      size: 'small',
      startIcon: <FileDownloadOutlinedIcon />,
    };
  
    return (
        <Button
            {...buttonBaseProps}
            onClick={() => handleExport({ getRowsToExport: getFilteredRows, fileName: 'comunidades_autonomas' })}
        >
            Exportar CSV
        </Button>
    );
}

export interface IComunidadesAutonomasState {
    data: ComunidadAutonoma[];
    loading: boolean;
    selectedSex: string;
    openNewForm: boolean;
    openEditForm: boolean;
    openDeleteForm: boolean;
    openImportProgress: boolean;
    selectedComunidadAutonoma: GridRowId[];
    progress: number;
    checkBoxSelection: boolean;
    hasErrors: boolean;
    errorMessage: string;
    rowSelected: null | HTMLElement;
    openRowMenu: boolean;
    chartLabels: string[];
    chartTotals: number[];
}

export default class ComunidadesAutonomasView extends React.Component<{}, IComunidadesAutonomasState> {
    _file: any;
    _fileContent: any[] = [];
    _viewId: string = "-1";
    
    public constructor(props: {}) {
        super(props);

        this.state = {
            data: [],
            selectedSex: 'mujer',
            loading: true,
            openNewForm: false,
            openEditForm: false,
            openDeleteForm: false,
            openImportProgress: false,
            selectedComunidadAutonoma: [],
            checkBoxSelection: false,
            progress: 0,
            hasErrors: false,
            errorMessage: '',
            rowSelected: null,
            openRowMenu: false,
            chartLabels: [],
            chartTotals: []
        };
    }

    componentDidMount(): void {
        this.Get();
    }

    public render(): React.ReactElement<{}> {
        return (
            <FeatureManager entidad={Entity.ComunidadesAutonomas} operacion='Ver' showBuyOption>
                <SecurityTrimmer entity={Entity.ComunidadesAutonomas} permission={PermissionLevel.Ver} noAccessMessage='No tiene permisos para ver este contenido.'>
                    <Layout breadcrumb={
                        [
                            {
                                title: 'Inicio',
                                url: '/'
                            },
                            {
                                title: 'Comunidades autónomas',
                                url: ''
                            }
                        ]
                    }>
                        <Box className='stepper'>
                            <Grid container>
                                <Grid item xs={1}>
                                    <Typography>
                                        <HomeWorkOutlinedIcon className='mainIcon'/>
                                    </Typography>
                                </Grid>
                                <Grid item xs={9}>
                                    <Typography className='mainTitle'>
                                    Comunidades autónomas
                                    </Typography>
                                </Grid>
                                <SecurityTrimmer entity={Entity.ComunidadesAutonomas} permission={PermissionLevel.Administrar}>
                                    <Grid item xs={2} className='entitySettings'>
                                        <EntitySettings entity={Entity.ComunidadesAutonomas}/>
                                    </Grid>
                                </SecurityTrimmer>
                            </Grid>
                        </Box>
                        <Box className='main'>
                            {
                                this.state.loading && (
                                    <div style={{textAlign: 'center', marginTop: '40px'}}>
                                        <CircularProgress />
                                    </div>
                                )
                            }
                            {
                                !this.state.loading && this.state.data.length == 0 && (
                                    <Alert style={{marginTop: '40px'}} severity="warning">No se han encontrado resultados.</Alert>
                                )
                            }
                            {
                                !this.state.loading && this.state.data.length > 0 && (
                                    <DataGrid
                                        slots={{ toolbar: this.CustomToolbar.bind(this) }}
                                        autoHeight
                                        rows={this.state.data}
                                        slotProps={{ pagination: { labelRowsPerPage: 'Filas por página' } }}
                                        columns={this.GetColumns()}
                                        initialState={{
                                            pagination: {
                                                paginationModel: { page: 0, pageSize: 30 },
                                            },
                                        }}
                                        pageSizeOptions={[30, 60, 100]}
                                        checkboxSelection={this.state.checkBoxSelection}
                                        onRowSelectionModelChange={(row: GridRowSelectionModel) => {
                                            this.setState({
                                                selectedComunidadAutonoma: row,
                                                openNewForm: false,
                                                openImportProgress: false,
                                                openDeleteForm: false,
                                                openEditForm: false
                                            });
                                        }}
                                        hideFooter={this.state.data.length <= 30}
                                    />
                                )
                            }
                        </Box>
                        
                        <ComunidadAutonomaNew open={this.state.openNewForm} onSave={this.Get.bind(this)} />
                        <ComunidadAutonomaDelete open={this.state.openDeleteForm} id={this.state.selectedComunidadAutonoma as number[]} onDelete={this.Get.bind(this)} />
                        <ComunidadAutonomaEdit open={this.state.openEditForm} onSave={this.Get.bind(this)} selectedItem={this.GetSelectedComunidadAutonoma()}/>
                        <Dialog open={this.state.openImportProgress} fullWidth>
                            <DialogTitle>
                                Importando comunidades autónomas
                            </DialogTitle>
                            <DialogContent>
                                <Grid item xs={12} style={{padding: '20px 10px'}}>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <Box sx={{ width: '100%', mr: 1 }}>
                                            <LinearProgress variant="determinate" value={this.state.progress} />
                                        </Box>
                                        <Box sx={{ minWidth: 35 }}>
                                            <Typography variant="body2" color="text.secondary">
                                                {
                                                    `${this.state.progress}%`
                                                }
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Grid>
                            </DialogContent>
                        </Dialog>
                        <ErrorDialog open={this.state.hasErrors} message={this.state.errorMessage} />
                        <Menu
                            anchorEl={this.state.rowSelected}
                            open={this.state.openRowMenu}
                            onClose={() => {
                                this.setState(
                                    {
                                        rowSelected: null,
                                        openRowMenu: false
                                    }
                                );
                            }}
                        >
                            <MenuItem onClick={() => {
                                    this.setState(
                                        {
                                            openNewForm: false,
                                            openImportProgress: false,
                                            openEditForm: true,
                                            openDeleteForm: false,
                                            openRowMenu: false
                                        }
                                    );
                            }}>
                                <ListItemIcon>
                                    <EditIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText>Modificar</ListItemText>
                            </MenuItem>
                            <MenuItem onClick={() => {
                                    this.setState(
                                        {
                                            openNewForm: false,
                                            openImportProgress: false,
                                            openEditForm: false,
                                            openDeleteForm: true,
                                            openRowMenu: false
                                        }
                                    );
                            }}>
                                <ListItemIcon>
                                    <DeleteOutlineOutlinedIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText>Eliminar</ListItemText>
                            </MenuItem>
                        </Menu>
                    </Layout>
                </SecurityTrimmer>
            </FeatureManager>
        )
    }

    private GetSelectedComunidadAutonoma(): ComunidadAutonoma | undefined {
        return this.state.data.find((value: ComunidadAutonoma) => {
            return value.id == this.state.selectedComunidadAutonoma[0] as number;
        });
    }

    private Get(): void {
        this.setState({
            loading: true
        });

        let url = `${Common.END_POINT}/masters/comunidadesautonomas/${this._viewId}`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    data: response,
                    openNewForm: false,
                    openImportProgress: false,
                    openDeleteForm: false,
                    openEditForm: false,
                    selectedComunidadAutonoma: [],
                    loading: false,
                    hasErrors: false,
                    progress: 0
                }
            );
        }).fail(( jqXHR, textStatus, errorThrow) => {
            if(jqXHR.status == 401) {
                window.location.href = "/login?source=/masters/comunidadesautonomas";
                return;
            }

            this.setState(
                {
                    loading: false,
                    hasErrors: true
                }
            );
        })
    }

    private CustomToolbar() {
        return (
            <Stack direction={'row'} alignItems={'center'} className='toolbar' gap={'20px'}>
                <FeatureManager entidad={Entity.ComunidadesAutonomas} operacion='Crear'>
                    <SecurityTrimmer entity={Entity.ComunidadesAutonomas} permission={PermissionLevel.Crear}>
                        <Button startIcon={<AddOutlinedIcon />} variant={'contained'} onClick={() => {
                            this.setState(
                                {
                                    openNewForm: true,
                                    openImportProgress: false,
                                    openEditForm: false,
                                    openDeleteForm: false
                                }
                            );
                        }}>
                            Nuevo
                        </Button>
                    </SecurityTrimmer>
                </FeatureManager>
                {
                    this.state.selectedComunidadAutonoma.length == 1 && (
                        <FeatureManager entidad={Entity.ComunidadesAutonomas} operacion='Editar'>
                            <SecurityTrimmer entity={Entity.ComunidadesAutonomas} permission={PermissionLevel.Editar}>
                                <Button startIcon={<EditOutlinedIcon />} onClick={() => {
                                    this.setState(
                                        {
                                            openNewForm: false,
                                            openImportProgress: false,
                                            openEditForm: true,
                                            openDeleteForm: false
                                        }
                                    );
                                }}>
                                    Modificar
                                </Button>
                            </SecurityTrimmer>  
                        </FeatureManager>     
                    )
                }
                {
                    this.state.selectedComunidadAutonoma.length > 0 && (
                        <FeatureManager entidad={Entity.ComunidadesAutonomas} operacion='Eliminar'>
                            <SecurityTrimmer entity={Entity.ComunidadesAutonomas} permission={PermissionLevel.Eliminar}>
                                <Button startIcon={<DeleteOutlineOutlinedIcon />} onClick={() => {
                                    this.setState(
                                        {
                                            openNewForm: false,
                                            openImportProgress: false,
                                            openEditForm: false,
                                            openDeleteForm: true
                                        }
                                    );
                                }}>
                                    Eliminar
                                </Button>
                            </SecurityTrimmer>
                        </FeatureManager>
                    )
                }
                {
                    ExportButton()
                }
                <Stack direction={'row'} width={'30%'} style={{marginLeft: 'auto'}} justifyContent={'space-between'}>
                    <FormControlLabel style={{width: '100%'}} control={<Switch defaultChecked={this.state.checkBoxSelection} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        this.setState(
                            {
                                checkBoxSelection: event.target.checked,
                                openNewForm: false,
                                openImportProgress: false,
                                openEditForm: false,
                                openDeleteForm: false
                            }
                        );
                    }}/>} label={<Typography variant='body2' color={'text.secondary'}>Selección múltiple</Typography>} />
                    <EntityViews entity={Entity.ComunidadesAutonomas} selectedView={this._viewId} onChange={(viewId: string) => {
                        this._viewId = viewId;
                        this.Get();
                    }}/>
                </Stack>
            </Stack>
        )

    }

    private RenderCellExpand(params: GridRenderCellParams<any, string>) {
        console.log(params);
        return (
            <React.Fragment>
                {
                    params.field == 'id' && (
                        Common.RenderCellMenuButton(params.value!, (event: React.MouseEvent<HTMLButtonElement>) => {
                            this.setState(
                                {
                                    rowSelected: event.currentTarget,
                                    openRowMenu: true
                                }
                            );
                        })
                    )
                }
                {
                    params.field == 'creadoPor' && (
                        Common.RenderUser(params.row, 'creadoPor')
                    )
                }
                {
                    params.field == 'modificadoPor' && (
                        Common.RenderUser(params.row, 'modificadoPor')
                    )
                }
                {
                    params.field == 'creado' && (
                        Common.RenderDate2(params.value!)
                    )
                }
                {
                    params.field == 'modificado' && (
                        Common.RenderDate2(params.value!)
                    )
                }
                {
                    params.field != 'id' && params.field != 'creadoPor' && params.field != 'creado' && params.field != 'modificado' && params.field != 'modificadoPor' && (
                        params.value
                    )
                }
            </React.Fragment>
        );
    }

    public GetColumns(): GridColDef[] {
        const firstRow = this.state.data[0];
        const columns: GridColDef[] = [];
        const keys = Object.getOwnPropertyNames(firstRow);

        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            if(key != 'creadoPorAvatar' && key != 'modificadoPorAvatar' && key != 'creadoPorAvatarColor' && key != 'modificadoPorAvatarColor') {
                let column: GridColDef = {} as GridColDef;
                column.field = key;
                column.headerName = Common.GetDataFieldDisplayName(key);
                column.width = key == 'id' ? 100 : 200;
                column.renderCell = this.RenderCellExpand.bind(this);

                if(i == keys.length - 1) {
                    column.flex = 1;
                }

                columns.push(column);
            }
        }

        return columns;
    }
}
